import React from 'react';
import { Twitter, Github, Heart } from 'lucide-react';
import { Theme } from '../types';

interface FooterProps {
  theme: Theme;
}

export default function Footer({ theme }: FooterProps) {
  return (
    <footer className={`py-8 mt-12 border-t ${
      theme === 'dark' 
        ? 'border-gray-800 text-gray-400' 
        : 'border-purple-100 text-gray-600'
    }`}>
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center justify-center space-y-4">
          <div className="flex items-center space-x-4">
            <a
              href="https://twitter.com/alexander"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-purple-500 transition-colors"
            >
              <Twitter size={20} />
            </a>
            <a
              href="https://github.com/alexander"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-purple-500 transition-colors"
            >
              <Github size={20} />
            </a>
          </div>
          <div className="text-center">
            <p className="mb-2">© 2024 0x41434f.</p>
            <p className="flex items-center justify-center text-sm">
              Crafted with <Heart size={14} className="mx-1 text-red-500" /> in Edgewood Library 
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
